import React from 'react';
import { capitalize } from "../services/_functions";
import PanelBills from "../panels/PanelBills";
import PanelRefund from "../panels/PanelRefund";
import PanelPay from "../panels/PanelPay";
import PanelWrongUser from "../panels/PanelWrongUser";
import PanelRefundProcess from "../panels/PanelRefundProcess";
import PanelPayProcess from "../panels/PanelPayProcess";

export default class RoutesAndPanels {

    static sharedInstance = RoutesAndPanels.sharedInstance == null ? new RoutesAndPanels() : this.sharedInstance;

    constructor() {
        this.routes = {};
    }

    setRoutes() {
        this.addRoute('main',               PanelBills);
        this.addRoute('pay',                PanelPay);
        this.addRoute('pay-process',        PanelPayProcess);
        this.addRoute('refund',             PanelRefund);
        this.addRoute('refund-process',     PanelRefundProcess);
        this.addRoute('wrong-user',         PanelWrongUser);
    }

    addRoute(url, panel, withNum = false, props = []) {
        this.routes[url] = {};
        this.routes[url]['url'] = url;
        this.routes[url]['panel'] = panel;
        this.routes[url]['id'] = 'panel' + capitalize(url);
        this.routes[url]['props'] = props;
        this.routes[url]['withNum'] = withNum;
    }

    getUrls() {
        const arr = Object.values(this.routes);

        return arr.map(route => (
            route['withNum'] ? route['url'] + '_\\d+' : route['url']
        ));
    }

    getSelectedPanel(route) {
        let selected = 'panelMain';
        const arr = Object.values(this.routes);

        for (let i = 0; i < arr.length; i++) {
            if (route.indexOf('_') === -1) {
                if (arr[i]['url'] === route) {
                    selected = arr[i]['id'];
                    break;
                }
            } else {
                if (arr[i]['url'] === route.split('_')[0]) {
                    selected = arr[i]['id'];
                    const urlNum = route.split('_')[1];
                    this.routes[arr[i]['url']]['props'] = { ...this.routes[arr[i]['url']]['props'], urlNum };
                    break;
                }
            }
        }

        return selected;
    }

    getSwipeStatus(url) {
        let swipeStatus = false;
        let route = url.substr(1);
        const arr = Object.values(this.routes);

        for (let i = 0; i < arr.length; i++) {
            if (route.indexOf('_') === -1) {
                if (arr[i]['url'] === route) {
                    swipeStatus = arr[i]['panel'].hasSwipe;
                    break;
                }
            } else {
                if (arr[i]['url'] === route.split('_')[0]) {
                    swipeStatus = arr[i]['panel'].hasSwipe;
                    break;
                }
            }
        }

        return swipeStatus;
    }

    renderPanel(route) {
        const Panel = route['panel'];
        return <Panel id={ route['id'] } key={ route['id'] } { ...route['props'] } />
    }

    renderPanels() {
        let arr = Object.values(this.routes);
        return arr.map(route => (
            this.renderPanel(route)
        ));
    }
}


// WEBPACK FOOTER //
// ./src/js/classes/_RoutesAndPanels.js